import { render, staticRenderFns } from "./AdmissionView.vue?vue&type=template&id=7ddc97f3&scoped=true&"
import script from "./AdmissionView.vue?vue&type=script&lang=js&"
export * from "./AdmissionView.vue?vue&type=script&lang=js&"
import style0 from "./AdmissionView.vue?vue&type=style&index=0&id=7ddc97f3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ddc97f3",
  null
  
)

export default component.exports